import React, { FC } from 'react';
import { X } from '@phosphor-icons/react';
import ExerciseSearchInput from './ExerciseSearchInput';
import { EmomSubExercise } from './workoutBuilderTypes';
import styles from './WorkoutBuilderModal.module.scss';

interface EmomSubExerciseRowProps {
  sub: EmomSubExercise;
  onChangeExercise: (exerciseId: string, exerciseName: string) => void;
  onChangeReps: (reps: string) => void;
  onRemove: () => void;
}

const EmomSubExerciseRow: FC<EmomSubExerciseRowProps> = ({
  sub,
  onChangeExercise,
  onChangeReps,
  onRemove,
}) => (
  <div className={styles.emomRow}>
    <div style={{ flex: 1 }}>
      <ExerciseSearchInput
        value={sub.exerciseName}
        onChange={(query) => onChangeExercise('', query)}
        onSelect={(exercise) =>
          onChangeExercise(
            exercise._id,
            exercise.name.it || exercise.name.en || '',
          )
        }
      />
    </div>
    <input
      type="text"
      placeholder="Reps"
      value={sub.reps}
      onChange={(e) => onChangeReps(e.target.value)}
      className={styles.emomRepsInput}
    />
    <button
      type="button"
      onClick={onRemove}
      className={styles.emomRemoveBtn}
      title="Rimuovi"
    >
      <X size={13} weight="bold" />
    </button>
  </div>
);

export default EmomSubExerciseRow;
